import { AxiosPromise } from 'axios';
import axios from 'axios';
import { IGetGreeting } from '../models/homepageManagementOwner.model';

const uri = '/mgmt/homepage-management/owner';

export const getGreeting = (campusCode: string): AxiosPromise<IGetGreeting> => {
  return axios.get(`${uri}/${campusCode}`);
};

export const createGreeting = (data: FormData): AxiosPromise => {
  return axios.post(uri, data);
};

export const updateGreeting = (campusCode: string, data: FormData): AxiosPromise => {
  return axios.put(`${uri}/${campusCode}`, data);
};
